// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_Id = require("rescript/lib/js/belt_Id.js");
var MM_parser = require("./MM_parser.bs.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_HashSet = require("rescript/lib/js/belt_HashSet.js");
var MM_substitution = require("./MM_substitution.bs.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.bs.js");
var MM_progress_tracker = require("../utils/MM_progress_tracker.bs.js");

function applyAssertionResultEq(a, b) {
  if (Belt_Option.isNone(a.err) && Belt_Option.isNone(b.err) && a.frame.label === b.frame.label) {
    return MM_substitution.subsEq(a.subs, b.subs);
  } else {
    return false;
  }
}

function applyAssertionResultHash(a) {
  return Expln_utils_common.hash2(Expln_utils_common.hashStr(a.frame.label), MM_substitution.subsHash(a.subs));
}

var ApplyAssertionResultHash = Belt_Id.MakeHashable({
      hash: applyAssertionResultHash,
      eq: applyAssertionResultEq
    });

function iterateCombinationsRec(candidatesPerHyp, comb, hypIdx, skipCombinationsWithEmptyArgs, skipCombinationsWithoutEmptyArgs, combCnt, combCntMax, onCombCntMaxReached, combinationConsumer) {
  if (hypIdx === comb.length) {
    combCnt.contents = combCnt.contents + 1 | 0;
    if (combCnt.contents > combCntMax) {
      return Curry._1(onCombCntMaxReached, undefined);
    }
    var thereIsEmptyArg = comb.some(function (a) {
          return a === -1;
        });
    if (thereIsEmptyArg) {
      if (skipCombinationsWithEmptyArgs) {
        return /* Continue */0;
      } else {
        return Curry._1(combinationConsumer, comb);
      }
    } else if (skipCombinationsWithoutEmptyArgs) {
      return /* Continue */0;
    } else {
      return Curry._1(combinationConsumer, comb);
    }
  }
  var res = /* Continue */0;
  var c = 0;
  var maxC = Caml_array.get(candidatesPerHyp, hypIdx).length - 1 | 0;
  while(res === /* Continue */0 && c <= maxC && combCnt.contents <= combCntMax) {
    Caml_array.set(comb, hypIdx, Caml_array.get(Caml_array.get(candidatesPerHyp, hypIdx), c));
    if (!(Caml_array.get(comb, hypIdx) === -1 && skipCombinationsWithEmptyArgs)) {
      res = iterateCombinationsRec(candidatesPerHyp, comb, hypIdx + 1 | 0, skipCombinationsWithEmptyArgs, skipCombinationsWithoutEmptyArgs, combCnt, combCntMax, onCombCntMaxReached, combinationConsumer);
    }
    c = c + 1 | 0;
  };
  return res;
}

function iterateCombinations(numOfStmts, numOfHyps, stmtCanMatchHyp, combCntMax, debugLevel, combinationConsumer, errConsumer) {
  var candidatesPerHyp = Belt_Array.makeBy(numOfHyps, (function (param) {
          return [];
        }));
  var maxH = numOfHyps - 1 | 0;
  var maxS = numOfStmts - 1 | 0;
  for(var h = 0; h <= maxH; ++h){
    for(var s = -1; s <= maxS; ++s){
      if (Curry._2(stmtCanMatchHyp, s, h)) {
        Caml_array.get(candidatesPerHyp, h).push(s);
      }
      
    }
  }
  var idx = candidatesPerHyp.findIndex(function (candidates) {
        return candidates.length === 0;
      });
  if (idx !== -1) {
    if (debugLevel >= 2) {
      return Curry._1(errConsumer, {
                  TAG: /* NoUnifForArg */4,
                  args: [],
                  errArgIdx: idx
                });
    } else {
      return /* Continue */0;
    }
  }
  var comb = Belt_Array.make(numOfHyps, 0);
  var tooBigSearchSpaceDetected = {
    contents: false
  };
  var $$continue = iterateCombinationsRec(candidatesPerHyp, comb, 0, true, false, {
        contents: 0
      }, combCntMax, (function (param) {
          tooBigSearchSpaceDetected.contents = true;
          return Curry._1(errConsumer, {
                      TAG: /* TooManyCombinations */6,
                      frmLabels: undefined
                    });
        }), combinationConsumer);
  if ($$continue === /* Continue */0) {
    return iterateCombinationsRec(candidatesPerHyp, comb, 0, false, true, {
                contents: 0
              }, combCntMax, (function (param) {
                  if (!tooBigSearchSpaceDetected.contents) {
                    return Curry._1(errConsumer, {
                                TAG: /* TooManyCombinations */6,
                                frmLabels: undefined
                              });
                  } else {
                    return /* Continue */0;
                  }
                }), combinationConsumer);
  } else {
    return $$continue;
  }
}

function iterateSubstitutionsWithWorkVars(workVars, frm, allowNewVars, hypIdx, $$continue) {
  var initialNumOfWorkVars = workVars.newVars.length;
  var predefinedSubs = frm.subs.isDefined.slice();
  var nextVar = {
    contents: (workVars.maxVar + 1 | 0) + workVars.newVars.length | 0
  };
  var frmVars = [];
  var newVars = [];
  var newVarTypes = [];
  MM_substitution.applySubs(hypIdx < frm.hypsE.length ? Caml_array.get(frm.hypsE, hypIdx).expr : frm.frame.asrt, frm.subs, (function (frmVar) {
          var idx = frmVars.indexOf(frmVar);
          if (idx !== -1) {
            return Caml_array.get(newVars, idx);
          }
          var newVar = nextVar.contents;
          nextVar.contents = nextVar.contents + 1 | 0;
          frmVars.push(frmVar);
          newVars.push(newVar);
          newVarTypes.push(Caml_array.get(frm.frame.varTypes, frmVar));
          return newVar;
        }));
  var maxI = frmVars.length - 1 | 0;
  for(var i = 0; i <= maxI; ++i){
    var frmVar = Caml_array.get(frmVars, i);
    var newVar = Caml_array.get(newVars, i);
    var newVarType = Caml_array.get(newVarTypes, i);
    Caml_array.set(frm.subs.exprs, frmVar, [newVar]);
    Caml_array.set(frm.subs.begins, frmVar, 0);
    Caml_array.set(frm.subs.ends, frmVar, 0);
    Caml_array.set(frm.subs.isDefined, frmVar, true);
    workVars.newVars.push(newVar);
    workVars.newVarTypes.push(newVarType);
  }
  var res = allowNewVars || workVars.newVars.length === 0 ? Curry._1($$continue, undefined) : /* Continue */0;
  predefinedSubs.forEach(function (predefined, i) {
        Caml_array.set(frm.subs.isDefined, i, predefined);
      });
  workVars.newVars.splice(initialNumOfWorkVars);
  workVars.newVarTypes.splice(initialNumOfWorkVars);
  return res;
}

function getNextNonBlankIdx(hypIdx, comb) {
  var idx = hypIdx + 1 | 0;
  while(idx < comb.length && Caml_array.get(comb, idx) < 0) {
    idx = idx + 1 | 0;
  };
  if (idx < comb.length && Caml_array.get(comb, idx) >= 0) {
    return idx;
  }
  
}

function getNextBlankIdx(hypIdx, comb) {
  var idx = hypIdx + 1 | 0;
  while(idx < comb.length && Caml_array.get(comb, idx) >= 0) {
    idx = idx + 1 | 0;
  };
  if (idx < comb.length && Caml_array.get(comb, idx) < 0) {
    return idx;
  }
  
}

function getNextHypIdxToMatch(hypIdx, comb) {
  if (hypIdx >= comb.length) {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "getNextHypIdxToMatch: hypIdx >= comb->Js_array2.length"
          },
          Error: new Error()
        };
  }
  if (hypIdx < 0 || Caml_array.get(comb, hypIdx) >= 0) {
    var idx = getNextNonBlankIdx(hypIdx, comb);
    if (idx !== undefined) {
      return idx;
    }
    var idx$1 = getNextBlankIdx(-1, comb);
    if (idx$1 !== undefined) {
      return idx$1;
    } else {
      return comb.length;
    }
  }
  var idx$2 = getNextBlankIdx(hypIdx, comb);
  if (idx$2 !== undefined) {
    return idx$2;
  } else {
    return comb.length;
  }
}

function iterateSubstitutionsForHyps(workVars, frm, parenCnt, statements, allowNewVars, comb, hypIdx, debugLevel, onMatchFound, onErrFound) {
  var combToArgs = function (param) {
    return comb.map(function (idx) {
                if (idx >= 0) {
                  return Caml_array.get(statements, idx);
                } else {
                  return [];
                }
              });
  };
  if (hypIdx === comb.length) {
    var subsFound = {
      contents: false
    };
    var contunieInstruction = iterateSubstitutionsWithWorkVars(workVars, frm, allowNewVars, hypIdx, (function (param) {
            subsFound.contents = true;
            return Curry._1(onMatchFound, undefined);
          }));
    if (debugLevel >= 2 && !subsFound.contents) {
      return Curry._1(onErrFound, {
                  TAG: /* NewVarsAreDisabled */5,
                  args: combToArgs(undefined),
                  errArgIdx: hypIdx
                });
    } else {
      return contunieInstruction;
    }
  }
  if (Caml_array.get(comb, hypIdx) >= 0) {
    var subsFound$1 = {
      contents: false
    };
    var contunieInstruction$1 = MM_substitution.iterateSubstitutions(Caml_array.get(frm.hypsE, hypIdx).expr, Caml_array.get(statements, Caml_array.get(comb, hypIdx)), Caml_array.get(frm.frmConstParts, hypIdx), Caml_array.get(frm.constParts, hypIdx), Caml_array.get(frm.varGroups, hypIdx), frm.subs, parenCnt, (function (param) {
            subsFound$1.contents = true;
            return iterateSubstitutionsForHyps(workVars, frm, parenCnt, statements, allowNewVars, comb, getNextHypIdxToMatch(hypIdx, comb), debugLevel, onMatchFound, onErrFound);
          }));
    if (debugLevel >= 2 && !subsFound$1.contents) {
      return Curry._1(onErrFound, {
                  TAG: /* NoUnifForArg */4,
                  args: combToArgs(undefined),
                  errArgIdx: hypIdx
                });
    } else {
      return contunieInstruction$1;
    }
  }
  var subsFound$2 = {
    contents: false
  };
  var contunieInstruction$2 = iterateSubstitutionsWithWorkVars(workVars, frm, allowNewVars, hypIdx, (function (param) {
          subsFound$2.contents = true;
          return iterateSubstitutionsForHyps(workVars, frm, parenCnt, statements, allowNewVars, comb, getNextHypIdxToMatch(hypIdx, comb), debugLevel, onMatchFound, onErrFound);
        }));
  if (debugLevel >= 2 && !subsFound$2.contents) {
    return Curry._1(onErrFound, {
                TAG: /* NewVarsAreDisabled */5,
                args: combToArgs(undefined),
                errArgIdx: hypIdx
              });
  } else {
    return contunieInstruction$2;
  }
}

function checkDisj(frmDisj, subs, maxCtxVar, allowNewDisjForExistingVars, isDisjInCtx, debugLevel) {
  return MM_substitution.verifyDisjoints(frmDisj, subs, (function (n, m) {
                if (n <= maxCtxVar && m <= maxCtxVar && !Curry._2(isDisjInCtx, n, m)) {
                  return allowNewDisjForExistingVars;
                } else {
                  return true;
                }
              }), debugLevel);
}

function iterateSubstitutionsForResult(frm, result, parenCnt, consumer) {
  if (result !== undefined) {
    return MM_substitution.iterateSubstitutions(frm.frame.asrt, result, Caml_array.get(frm.frmConstParts, frm.numOfHypsE), Caml_array.get(frm.constParts, frm.numOfHypsE), Caml_array.get(frm.varGroups, frm.numOfHypsE), frm.subs, parenCnt, consumer);
  } else {
    return Curry._1(consumer, frm.subs);
  }
}

function applyAssertions(maxVar, frms, isDisjInCtx, statements, exactOrderOfStmtsOpt, allowEmptyArgsOpt, allowNewVarsOpt, result, parenCnt, frameFilterOpt, allowNewDisjForExistingVarsOpt, combCntMaxOpt, onMatchFound, debugLevelOpt, onProgress, param) {
  var exactOrderOfStmts = exactOrderOfStmtsOpt !== undefined ? exactOrderOfStmtsOpt : false;
  var allowEmptyArgs = allowEmptyArgsOpt !== undefined ? allowEmptyArgsOpt : true;
  var allowNewVars = allowNewVarsOpt !== undefined ? allowNewVarsOpt : true;
  var frameFilter = frameFilterOpt !== undefined ? frameFilterOpt : (function (param) {
        return true;
      });
  var allowNewDisjForExistingVars = allowNewDisjForExistingVarsOpt !== undefined ? allowNewDisjForExistingVarsOpt : false;
  var combCntMax = combCntMaxOpt !== undefined ? combCntMaxOpt : 10000;
  var debugLevel = debugLevelOpt !== undefined ? debugLevelOpt : 0;
  var sendNoUnifForAsrt = function (frm) {
    if (result !== undefined) {
      return Curry._1(onMatchFound, {
                  newVars: [],
                  newVarTypes: [],
                  frame: frm.frame,
                  subs: MM_substitution.subsClone(frm.subs),
                  err: {
                    TAG: /* NoUnifForAsrt */3,
                    asrtExpr: frm.frame.asrt,
                    expr: result
                  }
                });
    } else {
      return /* Continue */0;
    }
  };
  var numOfStmts = statements.length;
  var numOfFrames = frms.length;
  var progressState = MM_progress_tracker.progressTrackerMake(0.01, undefined, onProgress, undefined, undefined);
  var framesProcessed = {
    contents: 0
  };
  var continueInstr = {
    contents: /* Continue */0
  };
  var sentValidResults = Belt_HashSet.make(16, ApplyAssertionResultHash);
  frms.forEach(function (frm) {
        if (continueInstr.contents === /* Continue */0 && Curry._1(frameFilter, frm.frame)) {
          if (Belt_Option.getWithDefault(Belt_Option.map(result, (function (result) {
                        return Caml_array.get(result, 0) !== Caml_array.get(frm.frame.asrt, 0);
                      })), false)) {
            if (debugLevel >= 2) {
              continueInstr.contents = sendNoUnifForAsrt(frm);
            }
            
          } else {
            var subsForResFound = {
              contents: false
            };
            continueInstr.contents = iterateSubstitutionsForResult(frm, result, parenCnt, (function (param) {
                    subsForResFound.contents = true;
                    var numOfHyps = frm.numOfHypsE;
                    var workVars_newVars = [];
                    var workVars_newVarTypes = [];
                    var workVars = {
                      maxVar: maxVar,
                      newVars: workVars_newVars,
                      newVarTypes: workVars_newVarTypes
                    };
                    return iterateCombinations(numOfStmts, numOfHyps, (function (s, h) {
                                  if (s === -1) {
                                    if (exactOrderOfStmts) {
                                      return false;
                                    } else {
                                      return allowEmptyArgs;
                                    }
                                  } else if (!exactOrderOfStmts || s === h) {
                                    var stmt = Caml_array.get(statements, s);
                                    var hyp = Caml_array.get(frm.hypsE, h).expr;
                                    if (Caml_array.get(hyp, 0) !== Caml_array.get(stmt, 0)) {
                                      return false;
                                    }
                                    var res = {
                                      contents: false
                                    };
                                    MM_substitution.iterateSubstitutions(hyp, stmt, Caml_array.get(frm.frmConstParts, h), Caml_array.get(frm.constParts, h), Caml_array.get(frm.varGroups, h), frm.subs, parenCnt, (function (param) {
                                            res.contents = true;
                                            return /* Stop */1;
                                          }));
                                    return res.contents;
                                  } else {
                                    return false;
                                  }
                                }), combCntMax, debugLevel, (function (comb) {
                                  return iterateSubstitutionsForHyps(workVars, frm, parenCnt, statements, allowNewVars, comb, getNextHypIdxToMatch(-1, comb), debugLevel, (function (param) {
                                                var err = checkDisj(frm.frame.disj, frm.subs, maxVar, allowNewDisjForExistingVars, isDisjInCtx, debugLevel);
                                                if (err !== undefined) {
                                                  if (debugLevel === 0) {
                                                    return /* Continue */0;
                                                  } else {
                                                    return Curry._1(onMatchFound, {
                                                                newVars: workVars_newVars.slice(),
                                                                newVarTypes: workVars_newVarTypes.slice(),
                                                                frame: frm.frame,
                                                                subs: MM_substitution.subsClone(frm.subs),
                                                                err: err
                                                              });
                                                  }
                                                }
                                                var res_newVars = workVars_newVars.slice();
                                                var res_newVarTypes = workVars_newVarTypes.slice();
                                                var res_frame = frm.frame;
                                                var res_subs = MM_substitution.subsClone(frm.subs);
                                                var res = {
                                                  newVars: res_newVars,
                                                  newVarTypes: res_newVarTypes,
                                                  frame: res_frame,
                                                  subs: res_subs,
                                                  err: undefined
                                                };
                                                if (!Belt_HashSet.has(sentValidResults, res)) {
                                                  Belt_HashSet.add(sentValidResults, res);
                                                  return Curry._1(onMatchFound, res);
                                                } else {
                                                  return /* Continue */0;
                                                }
                                              }), (function (err) {
                                                return Curry._1(onMatchFound, {
                                                            newVars: [],
                                                            newVarTypes: [],
                                                            frame: frm.frame,
                                                            subs: MM_substitution.subsClone(frm.subs),
                                                            err: err
                                                          });
                                              }));
                                }), (function (err) {
                                  return Curry._1(onMatchFound, {
                                              newVars: [],
                                              newVarTypes: [],
                                              frame: frm.frame,
                                              subs: MM_substitution.subsClone(frm.subs),
                                              err: err
                                            });
                                }));
                  }));
            if (debugLevel >= 2 && !subsForResFound.contents) {
              continueInstr.contents = sendNoUnifForAsrt(frm);
            }
            
          }
        }
        framesProcessed.contents = framesProcessed.contents + 1;
        MM_progress_tracker.progressTrackerSetCurrPct(progressState, framesProcessed.contents / numOfFrames);
      });
}

exports.applyAssertionResultEq = applyAssertionResultEq;
exports.applyAssertionResultHash = applyAssertionResultHash;
exports.ApplyAssertionResultHash = ApplyAssertionResultHash;
exports.applyAssertions = applyAssertions;
exports.iterateCombinations = iterateCombinations;
exports.getNextHypIdxToMatch = getNextHypIdxToMatch;
/* ApplyAssertionResultHash Not a pure module */
